import { render } from "./BatchesModal.vue?vue&type=template&id=16aac6f4&scoped=true"
import script from "./BatchesModal.vue?vue&type=script&lang=js"
export * from "./BatchesModal.vue?vue&type=script&lang=js"

import "./BatchesModal.vue?vue&type=style&index=0&id=16aac6f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16aac6f4"]])

export default __exports__